import { useCallback, useSyncExternalStore } from 'react';

import type { FilterCompositionStore } from '../store/filterCompositionStore.types.js';

const getServerSnapshot = (): string => '';

/**
 * Subscribes to the FilterField value of a store that may not exist yet.
 *
 * The shipped `_useFilterCompositionState` throws without a resolvable store; a
 * component that references a composition by id has to tolerate the store being
 * absent and keep rendering.
 * @internal
 */
export function useFilterFieldValueOf(
  store: FilterCompositionStore | undefined,
): string {
  return useSyncExternalStore(
    useCallback(
      (onStoreChange: () => void) =>
        store === undefined ? () => undefined : store.subscribe(onStoreChange),
      [store],
    ),
    () => store?.getState().filterField ?? '',
    getServerSnapshot,
  );
}
